import { render, staticRenderFns } from "./FormAttachment.vue?vue&type=template&id=167e023e&scoped=true"
import script from "./FormAttachment.vue?vue&type=script&lang=js"
export * from "./FormAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167e023e",
  null
  
)

export default component.exports